module.exports = __webpack_public_path__ + "static/media/item-1.8b929915.jpeg";